import React, { useState, useEffect, useContext } from 'react';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';
import Inputs from 'components/inputs/inputs';
import moment from 'moment';

export default function OrderDetailsPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Orders, 'Order Details');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Orders', href: '/Orders' }, { name: 'Order Details', selected: true }]);
  }, []);

  return (
    <div className='row justify-content-md-center mx-0 mt-4'>
      <div className='col-12 col-md-10 col-lg-4 col-xl-3'>
        <Panel>
          <Panel.Header>Order Details</Panel.Header>
          <Panel.Body>
            <div className='alert alert-primary d-flex align-items-center justify-content-center'>
              <i className='icons8-box-important h4 my-0 mr-2' />
              <div className='important'>Waiting for Approval</div>
            </div>
            <div className='alert alert-success d-flex align-items-center justify-content-center'>
              <i className='icons8-ok-2 h4 my-0 mr-2' />
              <div className='important'>Approved</div>
            </div>
            <div className='alert alert-danger d-flex align-items-center justify-content-center'>
              <i className='icons8-cancel-2 h4 my-0 mr-2' />
              <div className='important'>Rejected</div>
            </div>
            <div className='mb-2'>
              <div><div className='form-label'>Application</div></div>
              <div><div className='form-label'>+</div>&nbsp;POSiCloud Reporting</div>
              <div><div className='form-label'>+</div>&nbsp;POSiCloud QME</div>
            </div>
            <div className='mb-2'>
              <div><div className='form-label'>Dealership</div></div>
              <div>AM/PM Service (Arizona)</div>
            </div>
            <div className='mb-2'>
              <div><div className='form-label'>Sales Contact</div></div>
              <div>Randy Johnson</div>
              <div className='subtle'>rjohnson@ampm.com</div>
              <div className='subtle'>123-456-7890</div>
            </div>
            <div className='mb-2'>
              <div><div className='form-label'>Special Instructions</div></div>
              <div className='subtle'>None</div>
            </div>
            <div className='status small'>
              <div>Created {moment().format('dddd, MMMM D, YYYY h:mma')}</div>
              <div>Modified {moment().format('dddd, MMMM D, YYYY h:mma')}</div>
            </div>
          </Panel.Body>
        </Panel>
      </div>
      <div className='col-12 col-md-10 col-lg-7 col-xl-8'>
        <ApprovalPanel />
        <WorkflowPanel />
      </div>
    </div>
  );
}

function ApprovalPanel(props) {
  return (
    <Panel>
      <Panel.Header>Approval</Panel.Header>
      <Panel.Body>
        <div className='row'>
          <EnterpriseInfo />
          <StoreInfo />
          <StoreInfo />
          <UserInfo />
        </div>

        <Inputs.Button variant='secondary' label='Approve' iconClass='icons8-checkmark' />
      </Panel.Body>
    </Panel>
  );
}

function WorkflowPanel(props) {
  return (
    <Panel>
      <Panel.Header>Order Status</Panel.Header>
      <Panel.Body className='bg-light-success'>
        <div className='d-flex align-items-center'>
          <h3 className='text-success mr-2'><i className='icons8-checked' /></h3>
          <h5>Enterprise</h5>
        </div>
      </Panel.Body>
      <Panel.Body className='bg-light-success'>
        <div className='d-flex align-items-center'>
          <h3 className='text-success mr-2'><i className='icons8-checked' /></h3>
          <h5>Stores</h5>
        </div>
      </Panel.Body>
      <Panel.Body className='bg-light-primary'>
        <div className='d-flex align-items-center'>
          <h3 className='text-primary mr-2'><i className='icons8-submit-progress' /></h3>
          <h5>Licenses</h5>
        </div>
      </Panel.Body>
      <Panel.Body className=''>
        <div className='d-flex align-items-center'>
          <h3 className='mr-2'><i className='icons8-box-important' /></h3>
          <h5>User</h5>
        </div>
      </Panel.Body>
    </Panel>
  );
}

function EnterpriseInfo(props) {
  const data = {};
  const isNewEnterprise = true;

  const getAddressLine1 = () => {
    if (data.address) {
      return <div>{data.address}</div>
    }
    return null;
  };

  const getAddressLine2 = () => {
    if (data.address2) {
      return <div>{data.address2}</div>
    }
    return null;
  };

  const getAddressLine3 = () => {
    if (data.city && data.state) {
      return <div>{data.city}, {data.state} {data.zip}</div>
    }
    if (data.city || data.state || data.zip) {
      return <div>{data.city},{data.state} {data.zip}</div>
    }
    return null;
  };

  return (
    <div className='col-md-6 col-xl-4'>
      <div className={`card card-body card-light-${isNewEnterprise ? 'success' : 'default'} my-3`}>
        <div className='d-flex justify-content-between align-items-center mb-2'>
          <h4 className='my-1'>Enterprise</h4>
          {!isNewEnterprise ? null :
            <span className='badge badge-success mx-3'>NEW</span>
          }
        </div>
        <div className='mb-2'>
          <div><div className='form-label'>Name</div></div>
          <div className='mb-2'>{data.name}</div>
          <div><div className='form-label'>Phone</div></div>
          <div className='mb-2'>{data.phone}</div>
          <div><div className='form-label'>Address</div></div>
          <div className='mb-2'>
            {getAddressLine1()}
            {getAddressLine2()}
            {getAddressLine3()}
          </div>
        </div>
      </div>
    </div>
  );
}

function StoreInfo(props) {
  const data = {};

  const getAddressLine1 = () => {
    if (data.address) {
      return <div>{data.address}</div>
    }
    return null;
  };

  const getAddressLine2 = () => {
    if (data.address2) {
      return <div>{data.address2}</div>
    }
    return null;
  };

  const getAddressLine3 = () => {
    if (data.city && data.state) {
      return <div>{data.city}, {data.state} {data.zip}</div>
    }
    if (data.city || data.state || data.zip) {
      return <div>{data.city},{data.state} {data.zip}</div>
    }
    return null;
  };

  return (
    <div className='col-md-6 col-xl-4'>
      <div className='card card-body card-light-success my-3'>
        <div className='d-flex justify-content-between align-items-center mb-2'>
          <h4 className='my-1'>Store</h4>
          <span className='badge badge-success mx-3'>NEW</span>
        </div>
        <div className='mb-2'>
          <div><div className='form-label'>Key Number</div></div>
          <div className='mb-2'>{data.keyNumber}</div>
          <div><div className='form-label'>Name</div></div>
          <div className='mb-2'>{data.name}</div>
          <div><div className='form-label'>Phone</div></div>
          <div className='mb-2'>{data.phone}</div>
          <div><div className='form-label'>Address</div></div>
          <div className='mb-2'>
            {getAddressLine1()}
            {getAddressLine2()}
            {getAddressLine3()}
          </div>
        </div>
      </div>
    </div>
  );
}

function UserInfo(props) {
  const data = {};

  return (
    <div className='col-md-6 col-xl-4'>
      <div className='card card-body card-light-default my-3'>
        <div className='d-flex justify-content-between align-items-center mb-2'>
          <h4>User</h4>
        </div>
        <div className='mb-2'>
          <div><div className='form-label'>Name</div></div>
          <div className='mb-2'>{data.name}</div>
          <div><div className='form-label'>Phone</div></div>
          <div className='mb-2'>{data.phone}</div>
          <div><div className='form-label'>Email</div></div>
          <div className='mb-2'>{data.emailAddress}</div>
        </div>
      </div>
    </div>
  );
}